module.exports = __webpack_public_path__ + "da85450a4a3e190f0e7eae4053841c57.pdf";